import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';
import { Card, CardContent } from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';

export default function AdminAuditLogsPage() {
  const { data, isLoading } = useQuery({ queryKey: ['auditLogs'], queryFn: () => api.get('/audit/logs').then(r => r.data) });
  const logs = data?.data || [];
  return (
    <div className="space-y-6 animate-fade-in">
      <div><h1 className="text-2xl font-bold text-white">Audit Logs</h1><p className="text-sm text-slate-400">System audit trail</p></div>
      <Card><CardContent className="p-0"><div className="overflow-x-auto"><table className="w-full">
        <thead><tr className="border-b border-white/[0.06] bg-white/[0.02]">
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Action</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Entity</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">User</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">IP</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Date</th>
        </tr></thead>
        <tbody className="divide-y divide-white/[0.04]">
          {isLoading ? <tr><td colSpan={5} className="px-4 py-12 text-center text-slate-500">Loading...</td></tr> :
            logs.length === 0 ? <tr><td colSpan={5} className="px-4 py-12 text-center text-slate-500">No audit logs</td></tr> :
            logs.map((log: any) => (
              <tr key={log.id} className="hover:bg-white/[0.02]">
                <td className="px-4 py-3"><Badge status={log.action} /></td>
                <td className="px-4 py-3 text-sm text-slate-300">{log.entity}</td>
                <td className="px-4 py-3 text-sm text-slate-300">{log.user?.username || log.userId || '-'}</td>
                <td className="px-4 py-3 text-sm text-slate-400 font-mono text-xs">{log.ipAddress || '-'}</td>
                <td className="px-4 py-3 text-sm text-slate-400">{new Date(log.createdAt).toLocaleString()}</td>
              </tr>
            ))}
        </tbody>
      </table></div></CardContent></Card>
    </div>
  );
}
